import React, { ReactElement, ReactNode } from 'react'

export type UlProps = {
    children: ReactNode
    className?: string
}

export type LiProps = {
    children: ReactNode
    className?: string
}

/**
 *
 * @param children
 *
 */
const Ul: React.FC<UlProps> = ({ children, className }: UlProps): ReactElement => (
    <ul className={`ul ${className || ''}`}>{children}</ul>
)

const Li: React.FC<LiProps> = ({ children, className }: LiProps): ReactElement => (
    <li className={`ul-li ${className || ''}`}>{children}</li>
)

export { Li }

export default Ul
